import * as React from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCoursesAsync } from '../Courses/CourseStore/courseStoreSlice';
import { toast } from 'react-toastify';
import { updateOfferAsync } from './OfferStore/offerStoreSlice';
// import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const UpdateOfferForm = ({ fetchDefaultData, defaultData, handleClose }) => {
  const [selectedCourse, setSelectedCourse] = React.useState(null);
  const [offerType, setOfferType] = React.useState(null);
  const [offer, setOffer] = React.useState(null);
  const [expired, setExpired] = React.useState(false);
  const [dueDate, setDueDate] = React.useState(new Date());

  const dispatch = useDispatch();
  const { courses } = useSelector((state) => {
    const { coursesReducer } = state;

    return {
      courses: coursesReducer.courses,
    };
  });

  console.log({ selectedCourse });

  React.useEffect(() => {
    fetchData();
  }, []);

  React.useEffect(() => {
    setExpired(defaultData.expired);
    // setDueDate(dayjs(defaultData.dueDate));
  }, [defaultData]);

  const fetchData = () => {
    try {
      dispatch(getAllCoursesAsync())
        .unwrap()
        .then(() => {
          toast.success('All Courses fetched successfully.');
        });
    } catch (error) {
      toast.error('Courses could not be fetched. Please try again later!');
    }
  };

  const updateCourse = async () => {
    try {
      let payload = {
        _id: defaultData._id,
        courseId: defaultData.course._id,
        offerType: offerType,
        offer: offer,
        dueDate: dueDate,
        expire: expired,
      };
      dispatch(updateOfferAsync(payload))
        .unwrap()
        .then((res) => {
          toast.success(`Offer ${res.courseName} was updated successfully.`);
          fetchDefaultData();
          handleClose();
        });
    } catch (error) {
      console.log(error);
      toast.error('Offer could not be added. Please try again!');
    }
  };

  return (
    <Box sx={style}>
      <Box>
        <Typography>Update a Course</Typography>
        <Box alignItems="center">
          <Box my={2}>
            <Autocomplete
              disablePortal
              fullWidth
              onChange={(e, value) => setSelectedCourse(value)}
              id="combo-box-demo"
              options={courses}
              getOptionLabel={(option) =>
                String(
                  option.courseName +
                    ' ' +
                    option.courseCategory +
                    ' (' +
                    option.program.programName +
                    ')'
                )
              }
              defaultValue={defaultData.course}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Course"
                  variant="outlined"
                  size="small"
                />
              )}
              disabled
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              id="outlined-basic"
              label="Offer Type"
              variant="outlined"
              value={offerType}
              defaultValue={defaultData.offerType}
              onChange={(e) => setOfferType(e.target.value)}
              size="small"
              fullWidth
              disabled={expired}
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              id="outlined-basic"
              label="Offer"
              variant="outlined"
              value={offer}
              defaultValue={defaultData.offer}
              onChange={(e) => setOffer(e.target.value)}
              size="small"
              fullWidth
              disabled={expired}
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <TextField
              id="date"
              label="Due Date"
              type="date"
              fullWidth
              size="small"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={dueDate}
              // defaultValue={dayjs(defaultData.dueDate)}
              onChange={(e) => setDueDate(e.target.value)}
              disabled={expired}
            />
          </Box>
          <Typography variant="body2">
            Existing expiry date:{' '}
            {/* {dayjs(defaultData.dueDate).format('MMMM D, YYYY')} */}
          </Typography>

          <FormControlLabel
            control={
              <Switch
                defaultChecked={defaultData.expired}
                onChange={(e) => setExpired(e.target.checked)}
                value={expired}
              />
            }
            label="Expired"
          />
        </Box>
        <Box my={2}>
          <Button variant="contained" color="primary" onClick={updateCourse}>
            Update Course
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateOfferForm;
